export { default as Text } from './Text'
export { default as Media } from './Media'
export { default as Both } from './Both'



// WEBPACK FOOTER //
// ./src/modules/Games/Containers/PresentationSlider/index.js